import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ModernLayoutComponent } from './modern.component';
import { CalsoftNavigationModule } from 'src/app/global/components/navigation';
import { MessagesModule } from 'src/app/layout/common/messages/messages.module';
import { NotificationsModule } from 'src/app/layout/common/notifications/notifications.module';
import { SearchModule } from 'src/app/layout/common/search/search.module';
import { ShortcutsModule } from 'src/app/layout/common/shortcuts/shortcuts.module';
import { UserModule } from 'src/app/layout/common/user/user.module';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
    declarations: [
        ModernLayoutComponent
    ],
    imports     : [
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        CalsoftNavigationModule,
        MessagesModule,
        NotificationsModule,
        SearchModule,
        ShortcutsModule,
        UserModule,
        SharedModule
    ],
    exports     : [
        ModernLayoutComponent
    ]
})
export class ModernLayoutModule
{
}
